module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"occupied":"Occupied","free":"Free"},"de":{"occupied":"Besetzt","free":"Frei"},"fr":{"occupied":"Occupé","free":"Libre"},"it":{"occupied":"occupato","free":"libero"}}')
  delete Component.options._Ctor
}
